import axios from '../axios';

export const show = (lang) => {
  return axios.get(`/privacy-policy?lang=${lang}`);
};

export const submit = (payload) => {
  return axios.post('/privacy-policy', payload);
};
